<ng-container *transloco="let t; prefix: 'subscriptions.unsubscribeFeedbackThankyou'">
  <div class="mb-3 text-center">
    <rma-icon [rounded]="true" glyph="thumb_up" theme="primary" />
  </div>
  <h1 class="text-center text-body" [innerHTML]="t('heading')"></h1>
  <p>{{ t('text') }}</p>
</ng-container>
